import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src1997878616/src/nuxt/layouts/default.vue").then(m => m.default || m))
}